import _construct from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import { unpack, type } from '../../utils/index.js';
import chroma from '../../chroma.js';
import Color from '../../Color.js';
import input from '../input.js';
import hcg2rgb from './hcg2rgb.js';
import rgb2hcg from './rgb2hcg.js';
Color.prototype.hcg = function () {
  return rgb2hcg(this._rgb);
};
var hcg = function hcg() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return _construct(Color, args.concat(['hcg']));
};
chroma.hcg = hcg;
input.format.hcg = hcg2rgb;
input.autodetect.push({
  p: 1,
  test: function test() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    args = unpack(args, 'hcg');
    if (type(args) === 'array' && args.length === 3) {
      return 'hcg';
    }
  }
});
export { hcg };